import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { List, X } from "@phosphor-icons/react";

const LINKS = [
  { label: "Pillars", href: "#pillars" },
  { label: "Approach", href: "#manifesto" },
  { label: "Ebooks", href: "#ebooks" },
  { label: "Booking", href: "#booking" },
  { label: "Journal", href: "#journal" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "glass border-b border-brand-line" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-2 group"
        >
          <span className="font-serif text-2xl text-brand-text tracking-tight">
            TonyBrand<span className="text-brand-gold">29</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm text-brand-dim hover:text-brand-text transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-brand-gold hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-book"
            onClick={() => go("#booking")}
            className="hidden sm:inline-flex items-center rounded-full bg-brand-sage px-5 py-2.5 text-sm font-medium text-brand-bg hover:bg-brand-gold transition-colors duration-300"
          >
            Book a session
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-brand-text"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-brand-line px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-left text-lg font-serif text-brand-text"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </motion.header>
  );
};
